import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import VideoProduction from './pages/VideoProduction';
import Weddings from './pages/Weddings';
import Casting from './pages/Casting';
import RealEstate from './pages/RealEstate';

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/video-production" element={<VideoProduction />} />
          <Route path="/weddings" element={<Weddings />} />
          <Route path="/casting" element={<Casting />} />
          <Route path="/real-estate" element={<RealEstate />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
